/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import { useNavigate, useParams } from 'react-router-dom'; // Import the hook for routing/navigation
import {useEffect, useRef, useState} from 'react'; // Import necessary React hooks
import { GetEmployeOnContractById } from '../../../../reduxToolkit/Contractor/ContractorApi';
import { useDispatch, useSelector } from 'react-redux';
import TableFunction from '../../../../components/table/TableFunction';
import { VIEW_TYPE } from '../../../../enums/ViewType'; // Import toast for notifications
import ButtonActionsCard from '../../../../components/buttons/ButtonActionsCard';
import { ArrowRightIcon } from '../../../../components/buttons/IconButtons';
import routes from '../../../../Routes/routes';
import { SIMPLE_PAGINATION_MODEL } from '../../../../components/table/Model/TableModel';
import {USER_TYPE_NAME_MODEL} from "../../../../enums/userTypeEnum";
import {isSmWidth} from "../../../../Apis/functions";
import { permissionObj } from '../../../../Helpers/permission';

// Main component for managing contractor details cards
const ContractorEmployeeDetailsCardsApp = ({
    selectedList,
    setSelectedList,
    modified,
    setModified,
    isAllChecked,
    setIsAllChecked,
    subView,
    contractorId
}) => {
    const dispatch = useDispatch(); // Redux dispatch hook
    const navigate = useNavigate(); // Initialize navigate function for routing
    const { contractId } = useParams(); // Retrieve contractId
    const elementRefTab1 = useRef(null); // Initialize reference to a DOM element for styling adjustments
    const [results, setResults] = useState([]); // State to store the list of results
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const { user } = useSelector((state) => state.authenticatioauthennSlice);
    const userType = user?.data?.userType?.name;
    // Contractors manage their own contract, employees need the manage users permission to select and remove
    const canSelect =
        Boolean(contractorId) ||
        DEV ||
        permission?.includes(permissionObj.WEB_CONTRACTOR_CONTRACT_MANAGE_USERS);
    // Use useLayoutEffect to adjust element styles (positioning) after the layout is rendered
    useEffect(() => {
        if (elementRefTab1?.current && !isSmWidth()) {
            const rect = elementRefTab1.current.getBoundingClientRect(); // Get the element's position on the screen
            const distanceTop = rect.top + 20; // Calculate the top position of the element
            elementRefTab1.current.style.setProperty('--top-value', `${distanceTop}px`); // Update the custom CSS property for positioning
        }
    }, [results]); // Empty dependency array to run only once after the component mounts


    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = async (page) => {
        dispatch(
            GetEmployeOnContractById({
                id: contractId,
                contractPagination: SIMPLE_PAGINATION_MODEL.set({ page, rowsPerPage }),
            }),
        ).then(
            ({
                payload: {
                    data: { data, success },
                }
             }) => {
                if (success) {
                    setResults(data); // Set the results with the data from the response
                }
            }
        );
    };

    const { t, handleCheckboxChange, handleDeleteAll, pagination, rowsPerPage } = TableFunction({
        selectedList,
        setSelectedList,
        data: results,
        fixedPagination: false,
        hasContainer: true,
        labelRowsPerPage: 'employees_per_page',
        setIsAllChecked,
        view: VIEW_TYPE.GRID.name,
        getData,
        modified,
        setModified
    });

    const renderEmployeeButton = (character) => {
        let go;
        let back;
        if(userType === USER_TYPE_NAME_MODEL.EMPLOYEE){
            go =  routes.employee.contractorEmployeeDetails + character?.id;
            back =  routes.employee.contractDetails + contractId;
        }else{
            go= routes.contractor.employeeDetails + character?.id;
            back = routes.contractor.contractDetails + contractId;
        }

        return (
            <div className='d-flex justify-content-end align-items-start gap-2 stretch-self w-100'>
                <ButtonActionsCard
                    id='btn_cedc_actions_card'
                    name={'details'}
                    Icon={ArrowRightIcon}
                    onClick={() => navigate(go,{state: { backUrl: back, currentSubView: subView } })}
                />
            </div>
        );
    };
    // Return the necessary variables and functions for the component
    return {
        t, // Translation function for multi-language support
        DEV,
        permission,
        contractId,
        navigate, // Navigation function for routing between pages
        elementRefTab1, // Reference to the DOM element for styling adjustments
        results, // The results fetched from the API
        isAllChecked,
        pagination, // Pagination component
        handleCheckboxChange, // Function to handle checkbox selection
        handleDeleteAll,
        renderEmployeeButton,
        canSelect
    };
};

export default ContractorEmployeeDetailsCardsApp; // Export the component to be used in other parts of the app
